import { createWidget } from '@beep/sberpay-widget';
import { getUserAccountInfo } from "../../../getUserAccountInfo/dev";
import { getSendSberpaymPayment } from "./api/logic.regular";
export var sendSberpayPayment = getSendSberpaymPayment({
  getUserAccountInfo: getUserAccountInfo,
  createWidget: createWidget
});